const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Kuwait',
  code: 'KW',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    city: { label: 'Post Office', width: 0.5 },
    stateCode: { label: 'District' },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['stateCode'],
    ['address'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['stateCode'], ['address'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 54541'
    }
  ]
};
